export const breakpoints = {
    small: 0,
    large: 1024,
} as const
